import { ICompetition } from 'features/competitions-b2b';

export interface ICompetitionModel {
  id: number;
  name: string;
  description: string;
  description_short: string;
  date_start: string;
  date_end: string;
  date_award_start: string;
  date_award_end: string;
  objective_id: number;
  status: number;
  image_main: string;
  created_at: string;
  date_current_rating: string;
  participants_count: number;
}

export module IGetCompetitions {
  export interface Response {
    total: number;
    page: number;
    size: number;
    items: ICompetitionModel[];
    pages: number;
  }
  export interface Params {
    page: number;
    size: number;
    search: string;
  }
}

export module ICreateNewCompetition {
  export interface Response extends ICompetitionModel {}
  export interface Params extends ICompetition.ICompetitionsCreateFeatureForm {}
}

export module IChangeCompetition {
  export interface Response extends ICreateNewCompetition.Response {}
  export interface Params extends ICreateNewCompetition.Params {
    id: number;
  }
}

export module MChangeCompetitionStatus {
  export interface Response extends ICreateNewCompetition.Response {}
  export interface Params {
    status: 1 | 2 | 3 | 4 | 5;
    competition_id: number;
  }
}

export interface AwardModel {
  coins: null | number;
  prize_id: null | number;
  is_main: boolean;
  type?: string | null;
}

export interface IAwardsHolder {
  competition_id?: number;
  status?: number;
  award_place?: number;
  time_award_selection?: string;
  time_award_receiving?: string;
  place_start: number;
  place_end?: number | null;
  awards: AwardModel[];
}

export module IGetAdminAwards {
  export type Response = IAwardsHolder[];
  export interface Params {
    competition_id: number;
  }
}

export module IGetAdminCompetition {
  export interface Response {
    id: number;
    name: string;
    description: string;
    description_short: string;
    date_start: string;
    date_end: string;
    date_award_start: string;
    date_award_end: string;
    objective_id: number;
    status: 1 | 2 | 3 | 4 | 5;
    image_main: string;
    created_at: string;
    date_current_rating: string;
    participants_count: number;
  }
  export interface Params {
    competition_id?: number;
  }
}

export interface CompetitionStatsItem {
  day: number;
  date: string;
  purchase_amount: number;
}

export module IGetAdminCompetitionStats {
  export type Response = CompetitionStatsItem[];
  export interface Params {
    competition_id: number;
  }
}

export module IAddParticipantsToCompetitions {
  export interface Response {
    id: number;
    participants_count: number;
    new_participants_count: number;
    warnings: {
      line_number_error: string;
      warning: string;
      door_code: string;
    }[];
    detail?: [
      {
        msg: string;
        loc: [];
      },
    ];
  }
  export interface Params {
    competition_id: number;
    file: File;
  }
}

export module MGetAdminCompetitionItemAwards {
  export interface Response {}
  export interface Params {}
}

export interface IParticipantModel {
  id: number;
  user_id: number;
  title: string;
  competition_id: number;
  sales_point_id: number;
  place: number;
  purchase_amount_total: number;
  created_at: string;
}

export module MGetAdminCompetitionItemParticipants {
  export interface Response {
    total: number;
    page: number;
    size: number;
    items: IParticipantModel[];
    pages: number;
  }
  export interface Params {
    competition_id: number;
    order_by?: 'created_at' | 'place' | 'purchase_amount_total';
  }
}

export module MGetAdminCompetitionItemParticipant {
  export interface Response {
    title: string;
    purchase_amount_total: number;
  }
  export interface Params {
    competition_id: number;
    participant_id: number;
  }
}

export module MGetAdminCompetitionItemReport {
  export type Response = Blob;
  export interface Params {
    competition_id: number;
  }
}

export interface IRatingHistoryModel {
  competition_day: number;
  competition_date: string;
  purchase_amount: number;
  purchase_amount_today: number;
  place: number;
  place_change_status: number;
}

export module MGetAdminCompetitionItemRatingHistory {
  export type Response = IRatingHistoryModel[];
  export interface Params {
    competitionId: number;
    participantId: number;
  }
}

export interface IAwardChosenModel {
  coins: number | null;
  prize_id: number;
  is_main: boolean;
  id: number;
  prize: {
    id: number;
    name: string;
    description: string;
    image_main: string;
    estimation: number;
  };
}

export interface IAdminCompetitionPrizePlaceListModel {
  id: number;
  place: number;
  name: string;
  description: string;
  image_main: string;
  estimation: number;
  created_at: string;
  status: number;
  competition: {
    id: number;
    name: string;
  };
  award_chosen: IAwardChosenModel;
  time_award_selection: string;
  time_award_receiving: string;
}

export module MGetAdminCompetitionPrizePlaces {
  export interface Response {
    total: number;
    page: number;
    size: number;
    items: IAdminCompetitionPrizePlaceListModel[];
    pages: number;
  }
  export interface Params {
    search?: string;
    order_by?: 'created_at' | 'estimation';
    asc?: boolean;
    page: number;
    size: number;
    status?: number;
  }
}
export module MPatchDeliveryInfo {
  export type Response = void;
  export interface Params {
    address: string;
    tracking_number: string;
    comment_user: string;
    comment_admin: string;
    award_place_id: number;
  }
}

export module MGetAdminCompetitionPrizePlace {
  export interface Response {
    id: number;
    award_chosen?: IAwardChosenModel;
    place: number;
    status: number;
    time_award_selection: string;
    time_award_receiving: string;
    created_at: string;
    competition_obj: {
      id: number;
      name: string;
    };
    competition: ICompetitionModel;
    participant: {
      id: number;
      user_id: number[];
      sales_point?: {
        id: number;
        title: string;
        address: string;
      };
    };
    reason_reject: string;
    user: {
      id: number;
      first_name: string;
      last_name: string;
      middle_name: string;
      phone: string;
      scopes: string[];
    };
    places_to_awards_list: [
      {
        coins: number;
        prize_id: number;
        is_main: boolean;
        id: number;
        prize: {
          id: number;
          name: string;
          description: string;
          image_main: string;
          estimation: number;
        };
      },
    ];
    delivery_info: {
      id: number;
      created_at: string;
      address: string;
      tracking_number: string;
      comment_user: string;
      comment_admin: string;
    } | null;
  }
  export interface Params {
    award_place_id: number;
  }
}

export module MGetAdminCompetitionsReport {
  export type Response = Blob;
  export interface Params {}
}

export module MRejectAward {
  export interface Response {}
  export interface Params {
    reason_reject: string;
    awardPlaceId: number;
  }
}

export module MSendAward {
  export interface Response {}
  export interface Params {
    awardPlaceId: number;
  }
}

export module MAddCoins {
  export interface Response {}
  export interface Params {
    awardPlaceId: number;
  }
}

export module MGetCompetitionSalePoint {
  interface PartialParams {}
  export interface Response {}
  export interface Params extends Partial<PartialParams> {
    competition_id: number;
  }
}
